import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class TransformationService {
  public list: any = [];

  public baseUrl: string = "/transformation";

  constructor(private _httpClient: HttpClient) {}

  async getTransformationList() {
    return this._httpClient
      .get(this.baseUrl)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      });
  }

  async getSingleTransformation(id: number) {
    return this._httpClient.get(this.baseUrl + "/" + id).toPromise();
  }

  // create
  async createTransformation(data: any = {}) {
    return this._httpClient.post(this.baseUrl, data).toPromise();
  }

  // update
  async updateTransformation(id: number, data: any = {}) {
    return this._httpClient.put(this.baseUrl + "/" + id, data).toPromise();
  }

  //Disable and Restore, Restore status 1 disabled status 2
  async updateTransformationStatus(id: number, data: any) {
    return this._httpClient.put("/transformation/status/" + id, data).toPromise();
  }

  // delete
  async deleteTransformation(id: number) {
    return this._httpClient.delete(this.baseUrl + "/" + id).toPromise();
  }

  //Gestione iter documenti
  async updateDocumentStatus(id: number, data: any = {}) {
    return this._httpClient.put("/transformation/attachment/" + id, data).toPromise();
  }

  async request_masterdata_collaborator(hash: string) {
    return this._httpClient.get(`/collaborator/${hash}/request-masterdata`).toPromise();
  }

  async request_sign_contract_collaborator(hash: string) {
    return this._httpClient.get(`/collaborator/${hash}/request-sign-contract`).toPromise();
  }
}
